import Cookies from '@/utils/cookie-provider'

const getFingerprint = () => {
  return Cookies.get('fp')
}

const setFingerprint = (fingerprint) => {
  // Set cookie to expire in 10 years (effectively permanent)
  return Cookies.set('fp', fingerprint, { expires: 390, secure: true })
}

export { getFingerprint, setFingerprint }
